import React from "react";
import { Input } from "reactstrap";

const CustomInput = (props, ref) => {
  return <Input innerRef={ref} {...props} />;
};
export const FormInput = React.forwardRef(CustomInput);
